/*
 * @Author: liji
 * @Date: 2022-08-10 09:23:08
 * @LastEditors: liji
 * @LastEditTime: 2023-01-05 16:01:17
 * @Description: Antd Design 服务
 */
import { App } from "vue";
import {
    Button,
    Layout,
    Image,
    Dropdown,
    Menu,
    Form,
    Input,
    Row,
    Col,
    Select,
    Divider,
    Drawer,
    DatePicker,
    ConfigProvider,
    Table,
    Tooltip,
    Modal,
    Tag,
    Pagination,
    Comment,
    List,
    Avatar,
    Descriptions,
    Badge,
    Spin,
    Carousel,
    Tabs,
    Collapse,
    Popover,
    Empty,
    Popconfirm,
    Upload,
    Radio,
    Card,
    Switch
} from "ant-design-vue";

import zhCN from "ant-design-vue/es/locale/zh_CN";
import enUS from "ant-design-vue/es/locale/en_US";

export default class AntdDesignService {
    constructor(app: App<Element>) {
        this.componentsImport(app);
    }
    /**
     * @description: 组件注入
     * @param {App<Element>} app vue实例
     * @return {void}
     */
    componentsImport = (app: App<Element>): void => {
        app.use(Button)
            .use(Layout)
            .use(Image)
            .use(Dropdown)
            .use(Menu)
            .use(Form)
            .use(Input)
            .use(Row)
            .use(Col)
            .use(Select)
            .use(Divider)
            .use(Drawer)
            .use(DatePicker)
            .use(ConfigProvider)
            .use(Table)
            .use(Tooltip)
            .use(Modal)
            .use(Tag)
            .use(Pagination)
            .use(Comment)
            .use(List)
            .use(Avatar)
            .use(Descriptions)
            .use(Badge)
            .use(Spin)
            .use(Upload)
            .use(Carousel)
            .use(Tabs)
            .use(Collapse)
            .use(Popover)
            .use(Popconfirm)
            .use(Empty)
            .use(Radio)
            .use(Card)
            .use(Switch);
    };

    languages: objectType = {
        en: enUS,
        zh: zhCN
    };

    languageLocal = (language: string): any => {
        const languages = this.languages;
        if (languages[language]) {
            return languages[language];
        } else {
            throw new Error(`antd服务不支持${language}语言，需要添加`);
        }
    };
}
